var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomize({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.001,
    height: 50,
    viewBox: "0 0 50.001 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customize",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M0,0H15.91V54.8H0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 4, 15.251)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    d: "M0,0H2.5V7.956H0Z",
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 19.221, 19.221)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    d: "M0,0H2.5V4.42H0Z",
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 40.654, 29.404)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M0,0H2.5V4.42H0Z",
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 19.366, 8.116)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M0,0H2.5V4.42H0Z",
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 48.191, 36.941)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M0,0H2.5V4.42H0Z",
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 26.866, 15.616)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M0,0H7.956V2.5H0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 38.779, 38.782)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M44.429,10.084,39.865,5.521a1.782,1.782,0,0,0-2.519,0L35.2,7.671l7.081,7.08L44.429,12.6a1.784,1.784,0,0,0,0-2.52",
    transform: "translate(7.8 0.25)",
    fill: "#e57373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M0,0H45.009V10.015H0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 7.634, 43.285)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M0,0H5.008V10.015H0Z",
    transform: "matrix(-0.707, 0.707, -0.707, -0.707, 50.075, 15)",
    fill: "#b0bec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M7.381,35.429,5,44.893l9.464-2.383Z",
    transform: "translate(0.25 7.857)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M6.206,39.172,5,43.957l4.784-1.206Z",
    transform: "translate(0.25 8.793)",
    fill: "#37474f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.02069879ba9bd124b5ce980508cb0285.svg";
export { ForwardRef as ReactComponent };